export default __webpack_public_path__ + "static/media/premium-tea.8ad0867b.jpg";